<div class="container">
  @let bookingRedirect = bookingRequestRedirect();
  @if (isLoading()) {
    <div class="loader">
      <rds-progress-spinner
        label="Please wait, redirect in progress"></rds-progress-spinner>
    </div>
  }

  @if (error()) {
    <div class="error">
      <p>Booking request not found</p>
    </div>
  }

  @if (bookingRedirect) {
    @if (
      bookingRedirect.roomBookingRedirectType ===
      RoomBookingRedirectType.UNAUTHORIZED
    ) {
      <div class="error">
        <p>You are not authorized to view this booking request</p>
      </div>
    }
  }
</div>
